import React from "react";

export default (props) => (
    <button
        {...props}
        type="button"
        className={`btn btn-icon ${props.className ? props.className : ""}`}
    >
        {props.icon ? props.icon : props.children}
    </button>
);
